// For flag use country code from: https://react.semantic-ui.com/elements/flag/
export default [
  {
    key: "en",
    tKey: "en",
    path: "?lng=en",
    code: "EN",
    flag: "gb",
  },
  {
    key: "fi",
    tKey: "fi",
    path: "?lng=fi",
    code: "FI",
    flag: "fi",
  },
  {
    key: "pl",
    tKey: "pl",
    path: "?lng=pl",
    code: "PL",
    flag: "pl",
  },
  {
    key: "da",
    tKey: "da",
    path: "?lng=da",
    code: "DA",
    flag: "dk",
  },
  {
    key: "no",
    tKey: "no",
    path: "?lng=no",
    code: "NO",
    flag: "no",
  },
  {
    key: "sv",
    tKey: "sv",
    path: "?lng=sv",
    code: "SV",
    flag: "se",
  },
  {
    key: "nl-NL",
    tKey: "nl",
    path: "?lng=nl-NL",
    code: "NL",
    flag: "nl",
  },
  {
    key: "nl-BE",
    tKey: "nl",
    path: "?lng=nl-BE",
    code: "NL-BE",
    flag: "be",
  },
  {
    key: "fr-BE",
    tKey: "fr",
    path: "?lng=fr-BE",
    code: "FR-BE",
    flag: "fr",
  },
];
